import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Creators as SiteCreators } from '../../ducks/site/site'

class MuvicardMenuItem extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			menuOptionPath,
			closeMobileMenu,
			title,
			iconItem,
			route,
			renderUrl,
			viewBox
		} = this.props

		return (
			<React.Fragment>
				<span className="item-container">
					{renderUrl ? (
						<Link to={route} target="_blank">
							<div>
								<svg
									width="30px"
									height="30px"
									viewBox={viewBox || '0 0 576 512'}>
									<path d={iconItem} />
								</svg>
								<div>{title}</div>
							</div>
						</Link>
					) : (
						<Link to={route}>
							<div>
								<svg
									width="35px"
									height="30px"
									viewBox={this.props.viewBox || '50 -110 1792 1792'}>
									<path d={iconItem} />
								</svg>
								<span>{title}</span>
							</div>
						</Link>
					)}
				</span>
			</React.Fragment>
		)
	}
}

const mapStateToProps = ({ site }) => ({
	menuOptionPath: site.menuOptionPath
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			menuOptionPath: SiteCreators.menuOptionPath,
			closeMobileMenu: SiteCreators.closeMobileMenu
		},
		dispatch
	)

export default connect(mapStateToProps, mapDispatchToProps)(MuvicardMenuItem)
